import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MaterialModule} from "@shared/material.module";
import {AlienalaLoaderComponent} from "@shared/components/alienala-loader/alienala-loader.component";
import {ErrorDisplayComponent} from "@shared/components/error-display/error-display.component";
import {EmptyStateComponent} from "@shared/components/empty-state/empty-state.component";


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MaterialModule,
    AlienalaLoaderComponent,
    ErrorDisplayComponent,
    EmptyStateComponent
  ],
  exports: [
    CommonModule,
    MaterialModule,
    AlienalaLoaderComponent,
    ErrorDisplayComponent,
    EmptyStateComponent
  ]
})
export class SharedModule {
}
